import { render, staticRenderFns } from "./WEBHTML.vue?vue&type=template&id=96a8841a"
import script from "./WEBHTML.vue?vue&type=script&lang=js"
export * from "./WEBHTML.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports